import type { TNewRoureStack } from './types'

export const mappingRouteStack = (
  routeStack: TNewRoureStack[],
  newRouteStack: TNewRoureStack,
): TNewRoureStack[] => {
  if (!routeStack.length) {
    return [newRouteStack]
  }

  if (newRouteStack.option?.replace) {
    const index = routeStack.map((item) => item.path.split('?')[0]).indexOf(newRouteStack.path.split('?')[0])
    if (index !== -1) {
      console.log('replace', newRouteStack)
      return [...routeStack.slice(0, index)]
    }
  }

  const index = routeStack.map((item) => item.path).indexOf(newRouteStack.path)
  if (index !== -1) {
    return [...routeStack.slice(0, index), newRouteStack]
  }

  return [...routeStack, newRouteStack]
}
